<template>
  <b-container class="mt-2 mb-2">
    <b-row>
      <b-col cols="12">
        <div class="tableWrapper w-100" ref="sidsTable">
          <b-row class="virtual-table-list-header" :class="{ hasScroll: this.sidResults.length > 5 }">
            <b-col
              cols="8"
              @click="setSort('name')"
              class="sortable"
              :class="{
                asc: this.orderBy === 'name' && this.orderAsc,
                desc: this.orderBy === 'name' && !this.orderAsc,
              }"
            >
              {{ this.$t('common.name') }}
            </b-col>
            <b-col
              cols="2"
              @click="setSort('sri')"
              class="sortable"
              :class="{ asc: this.orderBy === 'sri' && this.orderAsc, desc: this.orderBy === 'sri' && !this.orderAsc }"
            >
              {{ this.$t('search.label.sri') }}
            </b-col>
            <b-col
              cols="2"
              @click="setSort('rhp')"
              class="sortable"
              :class="{ asc: this.orderBy === 'rhp' && this.orderAsc, desc: this.orderBy === 'rhp' && !this.orderAsc }"
            >
              {{ this.$t('search.label.rhp') }}
            </b-col>
          </b-row>
          <RecycleScroller
            class="scroller"
            :items="sidResults"
            :item-size="45"
            key-field="id"
            v-slot="{ item }"
            @visible="showOnSelectedSid"
          >
            <b-row
              class="virtual-table-list-row"
              :class="{ selected: item.index === selectedSidIndex }"
              @click="openSidDetails(item)"
            >
              <b-col cols="8">
                {{ item.name }}
              </b-col>
              <b-col cols="2">
                {{ item.sri }}
              </b-col>
              <b-col cols="2">
                {{ item.rhp }}
              </b-col>
            </b-row>
          </RecycleScroller>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'sids-table',
  components: {},
  props: {
    value: {},
    reference: {},
    selectedSid: {},
    orderBy: String,
    orderAsc: Boolean,
  },
  data() {
    return {
      selectedSidIndex: this.selectedSid,
    }
  },
  computed: {
    sidFields: function () {
      return [
        {
          key: 'name',
          label: this.$t('common.name'),
          sortable: true,
        },
        {
          key: 'sri',
          label: this.$t('search.label.sri'),
          sortable: true,
        },
        {
          key: 'rhp',
          label: this.$t('search.label.rhp'),
          sortable: true,
        },
      ]
    },
    sidResults: function () {
      return this.value
    },
  },
  methods: {
    setSort(column) {
      let orderBy = this.orderBy
      let orderAsc = this.orderAsc

      if (orderBy === column) {
        orderAsc = !orderAsc
      } else {
        orderAsc = true
      }
      orderBy = column

      this.$emit('setSort', { orderBy, orderAsc })
      this.showOnSelectedSid()
    },
    openSidDetails(item) {
      this.selectedSidIndex = item.index
    },
    showOnSelectedSid() {
      this.$nextTick(() => {
        const sidsTable = document.querySelector('.vue-recycle-scroller')
        sidsTable.scrollTo({ top: (this.selectedSidIndex - 2) * 45, left: 0, behavior: 'smooth' })
      })
    },
  },
  beforeUpdate() {
    if (this.selectedSidIndex != null && this.selectedSidIndex === 0) {
      this.$refs.sidsTable.scrollTop = 0
    }
  },
  mounted() {},
  watch: {
    selectedSid(newValue) {
      this.selectedSidIndex = newValue
    },
    selectedSidIndex(newValue) {
      this.$emit('update:selectedSid', newValue)
    },
  },
}
</script>
<style lang="scss" scoped>
.virtual-table-list-header {
  padding: 5px 0px 5px 10px;
  margin: 0px;
  background-color: transparent !important;
  border-bottom: 2px solid #dee2e6;
  color: black !important;
  vertical-align: middle !important;
  font-weight: bold;
  align-items: center;
  &.hasScroll {
    padding-right: 27px;
  }
  .sortable {
    background-position: right 0.375rem center;
    background-repeat: no-repeat;
    background-size: 0.65em 1em;
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath opacity='.3' d='M51 1l25 23 24 22H1l25-22zm0 100l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");

    &.asc {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath d='M51 1l25 23 24 22H1l25-22z'/%3E%3Cpath opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");
    }

    &.desc {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3E%3Cpath d='M51 101l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");
    }
  }
}
.virtual-table-list-row {
  cursor: pointer;
  height: 45px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  &.selected {
    font-weight: bold;
    background-color: #dcdcdc !important;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.075);
  }
}
.virtual-table {
  .virtual-table-list {
    margin-bottom: 0;
    th {
      padding: 5px 10px !important;
      background-color: var(--secondaryBGColor) !important;
      color: black !important;
    }

    th,
    .kiid td {
      vertical-align: middle !important;
    }

    th.srri {
      padding-right: 20px !important;
      text-align: center;
    }

    td.srri {
      text-align: center;
    }

    .b-table-row-selected {
      font-weight: bold;
      background-color: var(--tableSelectedItemColor) !important;
    }
    .table-selected {
      background-color: var(--tableSelectedItemColor) !important;
      font-weight: bold;
    }
    .b-table-sticky-header {
      margin: 0 !important;
    }
  }

  .tableWrapper {
    overflow: hidden;
    border: 1px var(--gray8) solid;
    border-radius: 0.5rem;
  }

  .fairmat-secondary-tabs li:first-child a {
    margin-left: 0px;
  }
}

.scroller {
  max-height: 180px;
}
/deep/ .table-selected {
  background-color: var(--tableSelectedItemColor) !important;
}

/deep/ .b-table-sticky-header {
  margin: 0 !important;
}

/deep/ .tableWrapper {
  overflow: visible;
  border: 0 !important;
  border-radius: 0 !important;
}

.vue-recycle-scroller {
  background-color: var(--primaryBGColor);
}
</style>
